import React, { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";

import CategoryTable from "./CategoryTable";
import { Pagination } from "antd";

const CategoryList = ({ data, getCategoryData, searchData, getCategoryData2, onChangeVal, initialVlue, handleChange, reset }) => {
  // const [val, setVal] = useState('')
  // const [count, setCount] = useState([])
  // useEffect(() => {
  //   if (data?.totalPages) {
  //     const arrr = []
  //     for (let i = 0; i < data.totalPages; i++) {
  //       arrr.push(i + 1)
  //     }
  //     setCount(arrr);
  //   }
  // }, [data])
  // const reset = () => {
  //   setVal('')
  //   getCategoryData()
  // }
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>Category</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/add-category" className="btn btn-success">
              <AiOutlinePlus /> Add New Category
            </Link>
          </div>
        </div>


        <div className="pageBody">
          <CategoryTable data={data?.data} getCategoryData={getCategoryData} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
        </div>
        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCount} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCount}
              />
            </div>
          </div>
        </div>


        {/* <nav aria-label="Page navigation example">
          <ul className="pagination" style={{ margin: "18px" }}>
            {count && count?.map((val) => {
              return <li className="page-item" onClick={() => { getCategoryData2(val) }}><a className="page-link" href="#">{val}</a></li>
            })}
          </ul>
        </nav> */}

        {/* <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>
                  Showing 1 to 3 of 3 entries (filtered from 12 total entries)
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="paginationPart">
                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    <li className="page-item">
                      <a className="page-link" href="#">
                        <BiChevronLeft />
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">
                        <BiChevronRight />
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default CategoryList;
